import styles from '../style.module.scss'
import http from '../../../../../shared/http'
import { TApi } from '../../../../../shared/const'

import Uploader from '../../../../../UI/Uploader'
import { useTranslation } from 'react-i18next'
export default function ParentalConfirmation(props) {
	const parentalConfirmationHashName = props.parentalConfirmationHashName
	const { t } = useTranslation()

	const downoload = () => {
		/*
		 * Die rollenunabhaengige Datei-Route: Dieselbe Kachel steht seit
		 * 23.08.2026 auch im Unternehmensprofil der Lehrkraft, und die
		 * Admin-Adresse haette dort 403 geantwortet. Wer welche Datei sehen
		 * darf, entscheidet ohnehin das Backend (services/documents).
		 */
		http.get(TApi.GET_FILES_DOCUMENT(parentalConfirmationHashName), {
			responseType: 'blob'
		}).then(({ data }) => {
			const file = new Blob([data], { type: data.type })
			const fileURL = URL.createObjectURL(file)
			window.open(fileURL)
		})
	}

	return (
		<Uploader
			accept="application/pdf"
			title={props.title || t('Parental Confirmation')}
			onClick={downoload}
			disabled={true}
			classNameContent={styles.uploader}
			classNameLabel={styles.wrapper}
			nameFile={props.originalName}
			reviewedParentalConfirmation={props.reviewedParentalConfirmation}
		/>
	)
}
